import { ExportFileResult, PedidoLineaTiendaListItemPaginatedList, PedidosLineasTiendaSearch } from "../models/dataModels";
import { ApiFetcher } from "../utils/ApiFetcher";
import { IServiceForIndex } from "../utils/base/BaseServices";
import { downloadFileFromBase64Array } from "../utils/ValuesFormatter";


export class PedidosLineasTiendaService
    implements IServiceForIndex<PedidosLineasTiendaSearch, PedidoLineaTiendaListItemPaginatedList> {


    search(searchData: PedidosLineasTiendaSearch): Promise<PedidoLineaTiendaListItemPaginatedList> {

        var apiFetcher = new ApiFetcher();
        var prom = apiFetcher.post<PedidosLineasTiendaSearch, PedidoLineaTiendaListItemPaginatedList>("intranet/pedidos-lineas-tienda/search", searchData);

        prom.then(res => {

            res.items.forEach((val) => {
                val.fechaPedido = val.fechaPedido != null ? new Date(val.fechaPedido) : null;
            });

            return res;
        });

        return prom;
    }

    delete(id: number): Promise<any> {
        throw new Error("Not Implemented");
    }

    exportExcel(search: PedidosLineasTiendaSearch): Promise<any> {
        var url = "intranet/pedidos-lineas-tienda/exportExcel";

        var apiFetcher = new ApiFetcher();
        var promise = apiFetcher.post<PedidosLineasTiendaSearch, ExportFileResult>(url, search)
            .then((result) => {
                downloadFileFromBase64Array(result.content, result.fileName, "application/octet-stream");
                return result;
            });
        return promise;
    }

}
